import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';

// show mobile view for phones & tablets
const breakpoint = mediaQueries.lg;

const ListWrapper = styled.div`
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    @media ${breakpoint} {
        overflow-x: hidden;
        flex-direction: column;
    }
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px ${colors.lightGray};
    }

    &::-webkit-scrollbar-thumb {
        background-color: #dadada;
    }
`;

const SidebarStyled = styled.div`
    width: 100%;
    @media ${breakpoint} {
        width: 25%;
    }
`;

const SidebarList = styled.ul`
    font-family: 'Red Hat Display', sans-serif;
    padding-left: 0;
    list-style: none;
    display: flex;
    margin-bottom: 0;
    padding: 0 20px;
    /* box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2); */

    @media ${breakpoint} {
        display: block;
        padding: 0;
    }
`;

const Sidebar = ({ children }) => (
    <SidebarStyled className="bg-ultra-light-gray">
        <ListWrapper>
            <SidebarList>{children}</SidebarList>
        </ListWrapper>
    </SidebarStyled>
);

Sidebar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

export default Sidebar;
